import * as MuiCore from '@mui/material'
import { C1Checkbox, C1CheckboxProps } from 'components/core/checkbox'
import React, { Dispatch, SetStateAction } from 'react'
import { CheckBoxGroupStyles } from './styles'

export type CheckBoxListProps = {
    checkboxList: C1CheckboxProps[]
    groupLabel?: string
    arrayState: string[]
    setArrayState: Dispatch<SetStateAction<string[]>>
}
export type CheckboxGroupProps = CheckBoxListProps

export const CheckboxGroup = ({
    checkboxList,
    groupLabel,
    arrayState,
    setArrayState,
}: CheckboxGroupProps): React.ReactElement => {
    const onChange = (event): void => {
        const id = event.target.value

        if (event.target.checked) {
            setArrayState((previousState) => [...previousState, id])
        } else {
            setArrayState((previousState) => previousState.filter((val) => val !== id))
        }
    }

    const isChecked = ({ id, arrayState: state }: { id: string; arrayState?: string[] }): boolean => {
        return (state || []).includes(id)
    }

    return (
        <MuiCore.FormGroup>
            {groupLabel && <MuiCore.FormLabel sx={CheckBoxGroupStyles.fieldLabel}>{groupLabel}</MuiCore.FormLabel>}
            {checkboxList.map(({ id, label }: C1CheckboxProps) => (
                <C1Checkbox
                    key={`checkbox_${id}`}
                    id={id}
                    value={id}
                    label={label}
                    checked={isChecked({ id, arrayState })}
                    onChange={onChange}
                />
            ))}
        </MuiCore.FormGroup>
    )
}
